import { CivilDate } from 'tc39-proposal-temporal';
// import { getCivilDateToday } from '@bingads-webui-universal/temporal-utitlities';
import { CSMLTimeFrame } from './constants';

export const getDateAddedChoiceOptions = (i18n, timeZone) => {
  // const yesterday = getCivilDateToday().plus({ days: -1 });
  const todayObj = i18n.getToday({ timeZone });
  const today = new CivilDate(todayObj.year, todayObj.month, todayObj.day);
  const last7day = today.plus({ days: -6 });
  const last30day = today.plus({ days: -29 });
  return [
    { key: CSMLTimeFrame.Today, text: i18n.getString(_TL_('Today')), range: { start: today, end: today } },
    { key: CSMLTimeFrame.Last7Days, text: i18n.getString(_TL_('Last 7 days')), range: { start: last7day, end: today } },
    { key: CSMLTimeFrame.Last30Days, text: i18n.getString(_TL_('Last 30 days')), range: { start: last30day, end: today } },
    { key: CSMLTimeFrame.Custom, text: i18n.getString(_TL_('Custom range')), range: null },
  ];
};
